<template>
  <add-input type="edit" :edit="editData" />
</template>

<script>
import AddInput from "./AddInput.vue";
import OptionService from "@/services/OptionService";

export default {
  name: "EditInput",
  props: {
    value: {
      required: true,
      default: false
    }
  },
  components: {
    AddInput
  },
  data: () => ({
    editData: ""
  }),
  watch: {
    value(inputCode) {
      if (inputCode) {
        OptionService.inputDetail({ inputCode }).then(res => {
          if (res.status === 200) {
            this.editData = res.data;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
          this.$emit("input", "");
        });
      }
    }
  }
};
</script>

<style>
</style>